module.exports = __webpack_public_path__ + "img/recruit.30f3c0df.png";